import { ICatalogueState } from '@signature-it/ngx-catalogue/store/interfaces';
import {Group, PriceDTO, GroupUserLinksFields, StockDTO, ProductFullSolrDTO, FavoritesDTO} from '@signature-it/ngx-catalogue/models';

export class CatalogueStateModel implements ICatalogueState {
    priceList: PriceDTO[];
    stockList: StockDTO[];
    groupUserLinksFields: GroupUserLinksFields[];
    loadingPriceList: boolean;
    loadingUserLinks: boolean;
    groupsTree: Group;
    loadingGroupsTree: boolean;
    currentGroup: Group;
    productSolrDoc: ProductFullSolrDTO;
    loadingProductSolrDoc: boolean;
    favoritesList: FavoritesDTO[];
    favoritesIds: number[];
    loadingFavoritesList: boolean;
    updatedFavoritesSuccess: boolean;
    removeFavoritesSuccess: boolean;
    processingAddToFavorites: boolean;

    constructor(attributes?: object) {
        attributes = attributes || {};

        this.stockList = attributes['stockList'];
        this.priceList = attributes['priceList'];
        this.groupUserLinksFields = attributes['groupUserLinksFields'];
        this.loadingPriceList = String(attributes['loadingPriceList']) === 'true';
        this.loadingUserLinks = String(attributes['loadingUserLinks']) === 'true';
        this.groupsTree = attributes['groupsTree'];
        this.loadingGroupsTree = String(attributes['loadingGroupsTree']) === 'true';
        this.currentGroup = attributes['currentGroup'];
        this.productSolrDoc = attributes['productSolrDoc'];
        this.loadingProductSolrDoc = String(attributes['loadingProductSolrDoc']) === 'true';
        this.favoritesList = attributes['favoritesList'];
        this.favoritesIds = attributes['favoritesIds'];
        this.loadingFavoritesList = attributes['loadingFavoritesList'] || true;
        this.updatedFavoritesSuccess = attributes['updatedFavoritesSuccess'] || false;
        this.removeFavoritesSuccess =  attributes['removeFavoritesSuccess'] || false;
        this.processingAddToFavorites =  attributes['processingAddToFavorites'] || false;
    }

}
